/*
 * File: c:\Users\t.boisseau\Desktop\AUTOBUY\AutobuyBackOffice\src\Utils\Response.utils.ts
 * Project: c:\Users\t.boisseau\Desktop\AUTOBUY\AutobuyBackOffice
 * Created Date: Thursday July 31st 2025
 * Author: Tommy Boisseau
 * -----
 * Last Modified: Thursday July 31st 2025 4:00:45 pm
 * Modified By: the developer formerly known as Tommy Boisseau at t.boisseau@autobuy.fr
 * -----
 * Copyright (c) 2025 Autobuy SAS
 * -----
 */

import { createElement, Dispatch, SetStateAction } from "react";

export const handleLine = (setLines: Dispatch<SetStateAction<{ key: string, value: string }[]>>) => (line: string) => {
    const trimmed = line.trim();
    if (!trimmed) return;

    const index = trimmed.indexOf(":");
    if (index === -1) return;

    const key = trimmed.slice(0, index).trim();
    const value = trimmed.slice(index + 1).trim();

    setLines((oldLines: { key: string, value: string}[]) => {
      const existingIndex = oldLines.findIndex(l => l.key === key);

      if (existingIndex === -1) {
        return [...oldLines, { key, value }];
      } else {
        const newLines = [...oldLines];
        newLines[existingIndex] = { key, value };
        return newLines;
      }
    });
};

export const manageMyRespDisplay = (myResult: {[key:string]: string } | string, setAdditionnalText: Dispatch<SetStateAction<JSX.Element[]>>) => {
  const myRes: JSX.Element[] = [];

  let data: { [key: string]: string } = {};

  if (typeof myResult === "string") {
    try {
      data = JSON.parse(myResult);
    } catch (e) {
      setAdditionnalText([createElement("p", { className: "m-1", key: myResult }, myResult)]);
      return;
    }
  } else {
    data = myResult;
  }

  for (const immatOrVin in data) {
      myRes.push(createElement("p", { className: "m-1", key: immatOrVin }, `${immatOrVin} : ${data[immatOrVin]}`));
  }
  if (myRes.length > 0)
      setAdditionnalText(prev => [...prev, ...myRes]);
}

export async function fetchWithStream(url: string, options: { method?: string; headers?: Record<string, string>; body?: BodyInit; } = {}, cb?: (line: string) => void): Promise<string> {
  const response = await fetch(url, options);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText);
  }

  const reader = response.body?.getReader();
  if (!reader) throw new Error("Pas de flux lisible");

  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { done, value } = await reader.read();
    if (value) buffer += decoder.decode(value, { stream: true });

    let lines = buffer.split("\n");
    buffer = lines.pop() || "";

    for (const line of lines) {
      if (cb && line.trim()) cb(line);
    }

    if (done) return buffer;
  }
}
